<template>
  <div>
    <div class="pricing-wrapper">
      <main class="pricing-main">
        <h1 class="pi-title">Conheça os planos</h1>
        <p class="pi-sub">Veja as opções disponíveis para sua equipe</p>
        <!-- Mesmos cards de "Planos e assinatura" (TEL-2465), sem a contratação: esta
             tela é só de consulta, para quem já está no modelo de plano. -->
        <PlanShowcase
          :plans="pricingList"
          title="Compare os planos"
          :assignable="false"
          @contact-sales="openWhatsApp" />
      </main>
    </div>
  </div>
</template>

<script>
import { loadAndMapOffers } from '../../services/pricing-offers'
import { ensureTailwindCdn } from '../../utils/subscription-plan-styles'
import { salesWebhookUrlFor } from '@/utils/whatsapp'
import PlanShowcase from './PlanShowcase.vue'

export default {
  name: 'PricingInformative',
  components: {
    PlanShowcase
  },
  data () {
    return {
      pricingList: []
    }
  },
  mounted () {
    ensureTailwindCdn()
    this.loadPricingOffers()
  },
  methods: {
    loadPricingOffers () {
      return loadAndMapOffers().then(list => {
        this.pricingList = list
      })
    },
    // "Falar com o time" do banner da campanha.
    openWhatsApp () {
      const organization = this.$store.state.auth.organization
      const url = salesWebhookUrlFor(organization && organization.domain)
      window.open(url, '_blank', 'noopener,noreferrer')
    }
  }
}
</script>

<style lang="scss" scoped>
// Mesmo fundo, largura e cabeçalho de "Planos e assinatura" (Pricing.vue e
// PricingRedesign.vue): direto no fundo cinza da página, sem o quadro branco do `.card`.
.pricing-wrapper {
  all: initial;
  display: block;
  width: 100%;
}

.pricing-main {
  display: block;
  padding: 0 16px 80px;
}

.pi-title {
  margin: 0 0 4px;
  font-family: 'Inter', ui-sans-serif, system-ui, sans-serif;
  font-size: 30px; line-height: 36px; font-weight: 600; letter-spacing: -0.75px; color: #0f172b;
}
.pi-sub {
  margin: 0 0 16px;
  font-family: 'Inter', ui-sans-serif, system-ui, sans-serif;
  font-size: 16px; line-height: 24px; color: #45556c;
}
</style>



// WEBPACK FOOTER //
// src/components/Subscription/PricingInformative.vue